import { Component } from '@angular/core'
import { Breadcrumb } from './breadcrumb'
import { BreadcrumbService } from './breadcrumb.service'


@Component({
  selector: 'breadcrumb',  
  template:`
    <ol class="breadcrumb">              
      <li class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs">            
        <a class="breadcrumb-item" *ngIf="!breadcrumb.terminal" href="" [routerLink]="[breadcrumb.url]">{{ breadcrumb.displayName | translate }}</a>
        <span class="breadcrumb-item active" *ngIf="breadcrumb.terminal">{{ breadcrumb.displayName | translate}}</span>
      </li>     
    </ol>    
    `
})
export class BreadcrumbComponent {
  breadcrumbs: Breadcrumb[]
  constructor(private breadcrumbService: BreadcrumbService) {
    this.breadcrumbService.breadcrumbChanged.subscribe((crumbs: Breadcrumb[]) => {
      this.onBreadcrumbChange(crumbs)
    })
  }

  private onBreadcrumbChange(crumbs: Breadcrumb[]) {
    this.breadcrumbs = crumbs
  }
}